import React from 'react';
import { formatPeriod } from '../utils/experience';
import styles from '../pages/Resume.module.scss';

function ExperienceItem({ company, companyUrl, position, startDate, endDate, location, projects, achievements, responsibilities }) {
    const period = formatPeriod(startDate, endDate);

    return (
        <div className={styles.experienceItem}>
            <div className={styles.experienceHeader}>
                <div>
                    <h4 className={styles.experienceCompany}>
                        {companyUrl ? (
                            <a
                                href={companyUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.companyLink}
                            >
                                {company}
                            </a>
                        ) : company}
                    </h4>
                    <p className={styles.experiencePosition}>{position}</p>
                </div>
                <div className={styles.experienceMeta}>
                    <span className={styles.period}>{period}</span>
                    <span className={styles.location}>{location}</span>
                </div>
            </div>

            {projects && (
                <div className={styles.experienceSection}>
                    <h5>Projects</h5>
                    <ul className={styles.projectList}>
                        {projects.map((project, idx) => (
                            <li key={idx} className={styles.projectItem}>
                                <span className={styles.projectName}>{project.name}</span>
                                {project.links && (
                                    <span className={styles.projectLinks}>
                                        ({project.links.map((link, i) => (
                                            <React.Fragment key={i}>
                                                {i > 0 && ', '}
                                                <a
                                                    href={link.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.projectLink}
                                                >
                                                    {link.label}
                                                </a>
                                            </React.Fragment>
                                        ))})
                                    </span>
                                )}
                                {project.note && (
                                    <span className={styles.projectNote}>{project.note}</span>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {responsibilities && (
                <div className={styles.experienceSection}>
                    <h5>Responsibilities</h5>
                    <ul>
                        {responsibilities.map((resp, idx) => (
                            <li key={idx}>{resp}</li>
                        ))}
                    </ul>
                </div>
            )}

            {achievements && (
                <div className={styles.experienceSection}>
                    <h5>Achievements</h5>
                    <ul>
                        {achievements.map((ach, idx) => (
                            <li key={idx}>{ach}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default ExperienceItem;
